import React, { useEffect, useRef, useState } from "react";
import { CSVLink } from "react-csv";

// Fetches the CSV rows on click (authenticated JSON request) then triggers
// CSVLink's own download — mirrors the existing daywisereports download
// pattern elsewhere in this app, since a plain <a href> can't carry the
// app's auth header.
function CsvExportButton({ fetchRows, filename }) {
  const [rows, setRows] = useState(null);
  const [loading, setLoading] = useState(false);
  const linkRef = useRef();

  const handleClick = async () => {
    setLoading(true);
    try {
      const data = await fetchRows();
      setRows(data && data.length ? data : []);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (rows && rows.length) linkRef.current?.link?.click();
    if (rows !== null) setRows(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rows]);

  return (
    <>
      <button
        type="button"
        onClick={handleClick}
        disabled={loading}
        className="px-3 py-1.5 rounded text-sm font-semibold bg-emerald-600 text-white hover:bg-emerald-700 disabled:opacity-60"
      >
        {loading ? "Preparing..." : "Download CSV"}
      </button>
      {rows && rows.length > 0 && <CSVLink data={rows} filename={filename} ref={linkRef} className="hidden" />}
    </>
  );
}

export default CsvExportButton;
